// RegenerateSyncResponse schema — legacy sync fallback for POST /ingest/regenerate-stage.
//
// Session 39: extracted from packages/web/src/api/ingest.ts (TS-only interface)
// into a shared Zod schema. Used when no Cloudflare Workflow binding is available
// (local dev / legacy deployments). Marked @deprecated — will be removed once
// all frontend regen flows use the v4 workflow path.
import { z } from 'zod';
export const RegenerateSyncResponseSchema = z.object({
    partialRegen: z.literal(true),
    stage: z.string(),
    chapterId: z.string().optional(),
    mode: z.string(),
    items: z.array(z.unknown()),
    stageError: z.string().optional(),
    _syncFallback: z.literal(true),
    _durationMs: z.number(),
}).passthrough();
//# sourceMappingURL=regen-sync-response.js.map